import { ReactNode } from "react"

type FormRowProps = {
   label: string
   description?: string
   children: ReactNode
   error?: string
}

export default function FormRow({ label, description, children, error }: FormRowProps) {
   return (
      <div className="grid lg:grid-cols-2 items-start gap-4">
         <div className="space-y-1">
            <label className="text-sm font-bold">{label}</label>
            {description && <p className="text-xs text-muted-foreground">{description}</p>}
            {error && <p className="mt-1 text-xs text-red-600">{error}</p>}
         </div>
         <div className="flex justify-center lg:justify-end ">{children}</div>
      </div>
   )
}
